import { Box, Button, Stack, Typography } from "@/common/styles/style";
import { styles } from "./style";
import { useNavigate } from "react-router-dom";
import { Routes } from "@/router/routes";

export default function ErrorScreen() {
  const navigate = useNavigate();

  const handleBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(Routes.LOGIN);
    }
  };

  return (
    <Box sx={styles.container}>
      <Stack spacing={5} sx={styles.stack}>
        <Typography variant="h1">404 Not Found</Typography>
        <Typography variant="h3" sx={styles.textBody}>
          お探しのページ一時的にアクセスができない状態にあるが、移動もしくは削除された可能性があります。
          <br />
          また、URL、ファイル名にタイプミスがないか再度ご確認ください。
        </Typography>
      </Stack>
      <Button variant="text" onClick={handleBack} sx={styles.moveButton}>
        <Typography variant="button">戻る</Typography>
      </Button>
    </Box>
  );
}
